import { render, staticRenderFns } from "./StudyProgram.vue?vue&type=template&id=44cf5d82&"
import script from "./StudyProgram.vue?vue&type=script&lang=js&"
export * from "./StudyProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports